export enum VerseTooltipVariantEnum {
  NEUTRAL = 'neutral',
  WARNING = 'warning',
}
